var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.5C8.34375 2.5 7 4.09375 7 6C7 7.9375 8.34375 9.5 10 9.5C11.6562 9.5 13 7.9375 13 6C13 4.09375 11.6562 2.5 10 2.5ZM10 8.5C8.875 8.5 8 7.40625 8 6C8 4.625 8.875 3.5 10 3.5C11.0938 3.5 12 4.625 12 6C12 7.40625 11.0938 8.5 10 8.5ZM19 0H1C0.4375 0 0 0.46875 0 1V11C0 11.5625 0.4375 12 1 12H19C19.5312 12 20 11.5625 20 11V1C20 0.46875 19.5312 0 19 0ZM1 1H3C3 2.125 2.09375 3 1 3V1ZM1 11V9C2.09375 9 3 9.90625 3 11H1ZM19 11H17C17 9.90625 17.875 9 19 9V11ZM19 8C17.3438 8 16 9.375 16 11H4C4 9.375 2.625 8 1 8V4C2.625 4 4 2.65625 4 1H16C16 2.65625 17.3438 4 19 4V8ZM19 3C17.875 3 17 2.125 17 1H19V3Z",
    fill: "#2A2A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashPayment);
export default __webpack_public_path__ + "static/media/cash-payment.370bbaa3.svg";
export { ForwardRef as ReactComponent };